import { render, staticRenderFns } from "./amazonPayButton.vue?vue&type=template&id=e5c823c6&scoped=true&"
import script from "./amazonPayButton.vue?vue&type=script&lang=js&"
export * from "./amazonPayButton.vue?vue&type=script&lang=js&"
import style0 from "./amazonPayButton.vue?vue&type=style&index=0&id=e5c823c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c823c6",
  null
  
)

export default component.exports